import { initialTableShow } from 'utils/settings';

export const mainTableConf = [
  {
    isSortable: true,
    field: 'occurredDate',
    title: 'Occurred Date',
    show: true,
    width: 172,
    valuesExport: ['occurredDate']
  },
  {
    isSortable: false,
    field: 'opportunityId',
    title: 'Opportunity Id',
    show: true,
    width: 172,
    valuesExport: ['opportunityId']
  },
  {
    isSortable: false,
    field: 'sentiment',
    title: 'Sentiment',
    show: true,
    width: 132,
    valuesExport: ['sentiment']
  },
  {
    isSortable: false,
    field: 'customerFeedback',
    title: 'Customer Feedback',
    show: true,
    width: 282,
    valuesExport: ['customerFeedback']
  }
];

export const exportConfigQbr = {
  exportUrl: '/customer/satisfaction/qbr/export',
  exportName: 'qbr',
  exportFormat: 'zip'
};

export const defaultFilters = {
  search: '',
  sentiment: []
};

export const defaultNavigation = {
  fieldName: 'occurredDate',
  direction: initialTableShow.direction,
  currentPage: initialTableShow.currentPage,
  itemsPerPage: initialTableShow.itemsPerPage
};

export const chartColor = {
  closed: '#4dc9f6',
  hold: '#ac89f3',
  open: '#ff829d',
  pending: '#fbdf9c',
  solved: '#6fcdcd'
};
